import Navbar from 'components/commons/Navbar'
import React from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import Profile from './profile/Profile'
import Text from 'components/_UI/Text'
import { FullyCentered } from 'styled/alignment/Center'
import colors from 'theme/colors'

export default function Users() {
  return (
    <UsersContainer>
      <Profile />
      <FullyCentered paddingTop="30%">
        <Text name='title'> Nenhuma atividade recente. </Text>
      </FullyCentered>
      <Navbar />
    </UsersContainer>
  )
}

const UsersContainer = styled(Column)`
    height: 100vh;
    background: ${colors.occasionalGrey};
    width: 100%;
`
